/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.sort.js";
//
//
//
//
//
//
import Swiper from "vux/src/components/swiper/swiper.vue";
import CopyRight from 'CopyRight';
import CompClinic from '@/components/CompClinic';
import { mapGetters, mapMutations, mapState, mapActions } from 'vuex';
import { GETTER_CLINICOBJ, ACTION_CLINICOBJ } from '@/store/mutation_types';
import wx from 'jweixin-1.2.0';
export default {
  data: function data() {
    return {
      clinic: null,
      clinicName: null,
      imgIndex: 0,
      imgArray: [] //图片列表

    };
  },
  components: {
    Swiper: Swiper,
    CopyRight: CopyRight,
    CompClinic: CompClinic
  },
  created: function created() {
    this.fetchClinicInfo();
  },
  computed: _objectSpread({}, mapGetters({
    GETTER_CLINICOBJ: GETTER_CLINICOBJ
  })),
  mounted: function mounted() {},
  methods: _objectSpread(_objectSpread({}, mapActions({
    ACTION_CLINICOBJ: ACTION_CLINICOBJ
  })), {}, {
    addImg: function addImg(imgUrl) {
      var obj = {
        url: 'javascript:',
        img: imgUrl
      };
      this.imgArray.push(obj);
    },
    sortNumber: function sortNumber(a, b) {
      return a - b;
    },

    /** 初始化诊所信息 */
    fetchClinicInfo: function fetchClinicInfo() {
      var _this = this;

      var that = this;
      console.log('introduce data ACTION_CLINICOBJ');
      this.ACTION_CLINICOBJ(true).then(function (data) {
        console.log('introduce data return');
        that.clinic = data.scrmClinic;
        var clinicName = data.scrmClinic.clinicName;
        window.document.title = clinicName;
        var images = data.scrmClinicImages;

        if (images && images.length > 0) {
          images.sort(function (x) {
            return _this.sortNumber(x.imageOrder);
          });

          for (var i = 0; i < images.length; i++) {
            var image = images[i];
            that.addImg(image.imageServerPath + image.imageRelativePath);
          }
        }
      });
    }
  })
};